import { useEffect } from 'react'

import { emitError } from '@features/observability/lib/errorBus'

export type ReportableError = Error & { digest?: string }

/**
 * Reports an error caught by a React error boundary through the error bus.
 *
 * React error boundaries (Next.js `error.tsx` / `global-error.tsx`) swallow
 * render errors before they reach `window.onerror`, so RUM's automatic error
 * collection never sees them. Every boundary must report explicitly. Routing
 * through the bus applies the shared throttle and keeps Datadog out of features.
 */
export const useReportError = (error: ReportableError, source: string) => {
  useEffect(() => {
    emitError({ error, message: error.message, source, context: { digest: error.digest } })
  }, [error, source])
}
